export const AUDIT_CLIENT_TABS = [
  { key: 'detail', label: 'Client Detail' },
  { key: 'sites', label: 'Sites' },
  { key: 'certificate', label: 'Certificate' },
  { key: 'audit', label: 'Audit' },
  { key: 'cycle', label: 'Cycle' },
  { key: 'document', label: 'Document' },
];

export const buildAuditClientWorkspaceUrl = (id) => `/crm/client/${encodeURIComponent(id)}/audit-workspace`;

export const getAuditClientTabs = () => AUDIT_CLIENT_TABS;

export const buildAuditClientDetailData = (crmClient = {}, auditWorkspace = {}) => {
  const companyId = auditWorkspace.companyId || auditWorkspace.resolvedCompanyId || auditWorkspace.clientId || crmClient.companyId || crmClient.clientId;

  return {
    ...crmClient,
    ...auditWorkspace,
    companyId,
    companyName: auditWorkspace.companyName || crmClient.companyName,
  };
};

export const getClientInitials = (name = '') => {
  const words = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return 'AC';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0][0]}${words[1][0]}`.toUpperCase();
};
